<template>
  <div class="macro_right">
    <!-- o没有权限-->
    <div v-if="!allKey.MACRO_DETAIL" class="noData no_data_container">
      <span class="img no_data_img"></span>
      <p>Sorry, Do not have permission</p>
    </div>

    <div v-else class="industry_right_container">
      <span
        :class="favouriteStatus ? 'isFavorite' : 'isNFavorite'"
        class="favourite_btn"
        @click="setFavouriteStatus"
      ></span>
      <span class="home-btn" @click="setIndexShow"></span>

      <p class="company_common_title">
        <span>Macro index search</span>
      </p>
      <!-- Search index -->
      <div class="contai">
        <title-temp title="Search index"></title-temp>
        <div class="tag_list">
          <div class="list-item">
            <div class="item-title">Country/Region</div>
            <div class="list-content">
              <el-tag
                :key="index"
                v-for="(item, index) of currentCountryList"
                closable
                :disable-transitions="false"
                @close="handleCloseCountry(item)"
              >{{ item }}</el-tag>
            </div>
          </div>
          <div class="list-item">
            <div class="item-title">Index name</div>
            <div class="list-content">
              <el-tag
                :key="index"
                v-for="(item, index) of currentCheckedAll"
                closable
                :disable-transitions="false"
                @close="handleCloseIndexItem(item)"
              >{{ Conver(item).name }}</el-tag>
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button @click="reset">Reset</el-button>
          <el-button type="primary" @click="searchResult">Display</el-button>
        </div>
      </div>

      <!-- Chart display -->
      <div class="chart-contai contai">
        <title-temp title="Chart display"></title-temp>
        <!-- <el-date-picker
          v-model="datePicker"
          type="daterange"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          align="right"
          value-format="yyyy-MM-dd"
          @change="searchResultChart"
        ></el-date-picker>-->
        <!--  -->
        <el-date-picker
          class="search-chart"
          v-model="datePickerDouble.startDate"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="Start Date"
          :picker-options="pickerOptionsStart"
        ></el-date-picker>
        <el-date-picker
          class="search-chart"
          v-model="datePickerDouble.endDate"
          type="date"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="End Date"
          :picker-options="pickerOptionsEnd"
        ></el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          circle
          size="mini"
          :disabled="!dateSearchDisabled"
          @click="searchResultChart"
        ></el-button>
        <!--  -->
        <line-chart
          :xData="xData"
          :serData="serData"
          v-loading="loadingChart"
          element-loading-spinner="fa fa-spinner fa-pulse fa-2x mt-3"
        ></line-chart>
      </div>

      <!-- search result -->
      <div class="downContainer contai">
        <el-button
          type="text"
          class="downLoadBtn paddingBtn"
          @click="downLoadFn()"
          v-if="allKey.MACRO_DOWNLOAD"
        >
          <i class="el-icon-download"></i>
          download
        </el-button>
        <title-temp title="Search results"></title-temp>
        <table-list
          :column="currentColumn"
          :tableData="currentData"
          :column200="true"
          v-loading="loadingTable"
          element-loading-spinner="fa fa-spinner fa-pulse fa-2x mt-3"
        ></table-list>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import { mapState, mapMutations } from "vuex";
import {
  getMacroCommon,
  setMacroListChecked,
  getFavouriteDetail,
  postSaveFavourite
} from "common/js/http/v2Api";
import column from "conf/macroColumn";
import TableList from "common/components/table";
import LineChart from "./components/BarLine";
import wordMap from "conf/macroChinese.js";
const color = [
  "#836FFF",
  "#71C671",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#FFC125",
  "#757575"
];

export default {
  components: {
    TitleTemp,
    TableList,
    LineChart
  },

  data() {
    return {
      currentColumn: column,
      currentData: [],
      xData: [],
      serData: [],
      worker: null,
      datePicker: [],

      favouriteStatus: false,
      favouriteId: null,
      userId: parseInt(this.Cookies.get("imsilkroad_userid")),
      userName: this.Cookies.get("imsilkroad_username"),
      // userId: 3091,
      // userName: "imtest",

      loadingChart: false,
      loadingTable: false,

      // 日期
      datePickerDouble: {
        startDate: "",
        endDate: ""
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.datePickerDouble.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.datePickerDouble.startDate;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      }
    };
  },

  created() {
    // this.runWorker();
    if (this.$route.query.id) {
      // alert(this.$route.query.id);
      this.getFavoriteDetailById(this.$route.query.id);
    }
  },

  methods: {
    //有id回显数据
    async getFavoriteDetailById(id) {
      const { result } = await getFavouriteDetail(id);
      if (result) {
        const list = JSON.parse(result.params);
        const Jsonlist = list.map(item => JSON.stringify(item));
        this.setMacroListChecked(Jsonlist);
        this.searchResult();
      }
    },

    runWorker(result) {
      function converTableWithWorker(result, column) {
        const data = result.data;
        if (!data.length) return;
        const columnCf = JSON.parse(JSON.stringify(column));
        const result1 = data.map(item => {
          result.columns.forEach(j => {
            if (j.isDate) {
              columnCf.push({
                label: j.title,
                field: j.field
              });
            }
          });
          // return itemData;
        });
        // 设置列
        return {
          columnCf,
          data: result.data
        };
      }

      //
      if (typeof Worker !== "undefined") {
        // 是的! Web worker 支持!
        this.worker = this.$worker
          .run(
            (result, column, cloneDeep) => {
              const data = result.data;
              if (!data.length) return;
              const columnCf = cloneDeep(column);
              const result1 = data.map(item => {
                result.columns.forEach(j => {
                  if (j.isDate) {
                    columnCf.push({
                      label: j.title,
                      field: j.field
                    });
                  }
                });
                // return itemData;
              });
              // 设置列
              return {
                columnCf,
                data: result.data
              };
            },
            [result, column, this.$lodash.cloneDeep]
          )
          .then(res => console.log("TCL: runWorker -> res", ""))
          .catch(e => console.log(e));
      } else {
        //抱歉! Web Worker 不支持
      }
    },

    destroyed() {
      // 通过赋值null的方式，释放掉worker引用，这样就可以关闭worker，这是作者在github上说的
      this.worker = null;
    },

    Conver(item) {
      if (typeof item == "string") {
        return JSON.parse(item);
      } else return item;
    },

    getDateChart() {
      if (!this.dateSearchDisabled) {
        return {
          start: this.$moment(new Date())
            .subtract(5, "years")
            .format("YYYY-MM-DD"),
          end: this.$moment(new Date()).format("YYYY-MM-DD")
        };
      } else {
        return {
          // start: this.datePicker[0],
          // end: this.datePicker[1]
          start: this.datePickerDouble.startDate,
          end: this.datePickerDouble.endDate
        };
      }
    },

    async searchResult() {
      const basicName = this.currentCheckedAll.map(
        item => item.name || JSON.parse(item).name
      );
      if (!basicName.length) return;

      let hash = [];
      for (let item of basicName) {
        if (!hash.includes(item)) {
          hash.push(item);
        }
        if (hash.length > 1) {
          this.$message({
            message: "You have selected different index names for comparison which may cause confusion of data presentation. Please do the comparison under the same index name. ",
            type: "warning",
            duration:5000
          });
          break;
        }
      }

      //清空时间
      this.datePickerDouble.startDate = "";
      this.datePickerDouble.endDate = "";

      this.loadingChart = true;
      this.loadingTable = true;

      const params = {
        api: "/api/queryIndictorData.html",
        methodType: "POST",
        params: {
          type: "EN_CEIC",
          basicNameArray: basicName,
          countryArray: this.currentCountryList,
          rate: "",
          start: this.getDateChart().start,
          end: this.getDateChart().end
        },
        userId: this.userId,
        userName: this.userName
      };
      const { result } = await getMacroCommon(params);
      if (!result) {
        this.loadingTable = false;
        this.loadingChart = false;
        this.currentData = [];
        this.serData = [];
        return;
      }
      this.converTableData(result);
      // this.runWorker(result);
      // console.log("TCL: searchResult -> workerTableData", workerTableData)
      // this.currentColumn = workerTableData.columnCf;
      // this.currentData = workerTableData.data;

      this.converChartData(result);
    },

    async searchResultChart() {
      const basicName = this.currentCheckedAll.map(
        item => item.name || JSON.parse(item).name
      );
      if (!basicName.length) return;

      this.loadingChart = true;

      const params = {
        api: "/api/queryIndictorData.html",
        methodType: "POST",
        params: {
          type: "EN_CEIC",
          basicNameArray: basicName,
          countryArray: this.currentCountryList,
          rate: "",
          start: this.getDateChart().start,
          end: this.getDateChart().end
        },
        userId: this.userId,
        userName: this.userName
      };
      const { result } = await getMacroCommon(params);
      if (!result) {
        this.loadingTable = false;
        this.loadingChart = false;
        this.currentData = [];
        this.serData = [];
        return;
      }
      this.converChartData(result);
    },

    converTableData(result) {
      const data = result.data;
      if (!data.length) return;
      const columnCf = this.$lodash.cloneDeep(column);
      const result1 = data.map(item => {
        result.columns.forEach(j => {
          if (j.isDate) {
            columnCf.push({
              label: j.title,
              field: j.field
            });
          }
        });
        // return itemData;
      });
      // 设置列
      this.currentColumn = columnCf;
      this.currentData = result.data;
      this.currentData.forEach((i, key) => {
        this.currentData[key].original_data_source = this.testChineseWord(
          i.original_data_source
        );
      });
      console.log("converTableData -> this.currentData", this.currentData);
      this.loadingTable = false;
    },

    converChartData(result) {
      const data = this.$lodash.cloneDeep(result.data);

      const result1 = data.map((item, index) => {
        const x_data = [];
        let countryName = item.country_cn_simplename
          ? ":" + item.country_cn_simplename
          : "";
        let unit = item.unit_cn_description?"(Unit:"+item.unit_cn_description+")":''

        const itemData = {
          name: item.cn_name + countryName + unit,
          type: "line",
          // stack: "dta",
          data: [],
          unit: item.unit_cn_description,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        result.columns.forEach(j => {
          if (j.isDate) {
            x_data.push(j.title);
            itemData.data.push(parseInt(item[j.field]) || 0);
          }
        });
        // Object.keys(item).forEach(j => {
        //   if (j.includes("_status")) {
        //     const key = j.split("_")[0];
        //     x_data.push(key);
        //     itemData[key] = item[key];
        //     itemData.data.push(item[key] || 0);
        //   }
        // });
        itemData.data = itemData.data.reverse();
        this.xData = x_data.reverse();
        return itemData;
      });
      const isLength = result1.filter(item => item.data.length);
      this.serData = isLength.length ? result1 : [];
      // this.serData = result1;
      console.log("converChartData -> this.serData", this.serData);

      this.loadingChart = false;
    },

    handleCloseIndexItem(item) {
      if (typeof item == "string") {
        const id = JSON.parse(item).id;
        this.deleteMacListed(id);
      } else {
        this.deleteMacTree(item.name);
      }
    },

    handleCloseCountry(item) {
      this.deleteMacTree({
        countryName: item,
        type: "country"
      });
      this.deleteMacListed({
        countryName: item,
        type: "country"
      });
    },

    reset() {
      this.macroReset();
      //修复bug标记 02
      this.currentData = [];
      this.serData = [];
      //
    },

    downLoadFn() {
      let result = "";
      let dataArray = [];
      dataArray = [...this.currentColumn.map(item => item.label)];

      result = dataArray.join(",") + `\n`; //先遍历得到表头信息

      this.currentData.forEach(item => {
        this.currentColumn.forEach(itemColumn => {
          result += `${item[itemColumn.field] + "\t"},`;
        });
        result += "\n";
      });

      //encodeURIComponent解决中文乱码
      let uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(result);
      //通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = `Macro Search results.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    setFavouriteStatus() {
      //准备收藏
      if (!this.favouriteStatus) {
        let url = window.location.href;
        // module收藏数据类型 1 企业 2 并购 3 行业 4 指标
        let params = {
          module: 4,
          params: {},
          title: "",
          userId: this.userId,
          url: url.split("?")[0]
        };

        const countryAndName = this.currentCheckedAll.map(item => ({
          name: item.name || JSON.parse(item).name,
          countryName: item.countryName || JSON.parse(item).countryName
        }));

        if (!countryAndName.length) {
          // Can't be empty
          this.$message({
            message: "Index name Cannot be empty!",
            type: "warning"
          });
          return;
        }

        params.params = JSON.stringify(countryAndName);

        this.$prompt("Please enter a title", "Notice", {
          confirmButtonText: "sure",
          cancelButtonText: "cancle"
        }).then(({ value }) => {
          params.title = value;
          this.saveFavorite(params);
        });
      }

      // this.favouriteStatus = !this.favouriteStatus;
    },

    //收藏
    async saveFavorite(params) {
      const { result } = await postSaveFavourite(params);
      // Collection of success
      this.$message({
        message: "Collection of success!",
        type: "success"
      });
    },

    setIndexShow() {
      this.changeIndexShow(true);
    },

    //是否包含中文
    testChineseWord(source) {
      //包含汉字
      if (/.*[\u4e00-\u9fa5]+.*$/.test(source)) {
        if (wordMap[source]) return wordMap[source];
      }
      return source;
    },

    ...mapMutations([
      "deleteMacTree",
      "macroReset",
      "deleteMacListed",
      "setMacroListChecked",
      "changeIndexShow"
    ])
  },

  computed: {
    ...mapState({
      currentCheckedAll(state) {
        return state.MacroChecked.ListChecked.concat(
          state.MacroChecked.treeChecked
        );
      },

      currentCountryList() {
        const countryList = this.currentCheckedAll.map(item => {
          if (typeof item == "string") {
            return JSON.parse(item).countryName;
          } else return item.countryName;
        });
        return Array.from(new Set(countryList));
      },

      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    }),

    dateSearchDisabled() {
      return (
        !!this.datePickerDouble.startDate && !!this.datePickerDouble.endDate
      );
    }
  }
};
</script>
<style scoped>
.macro_right {
  height: 100%;
  /* padding: 20px; */
}
.btnContainer {
  text-align: right;
  margin-top: 20px;
}
.list-item {
  border: 1px solid #f3f4f5;
  height: 76px;
  margin-bottom: 20px;
}
.list-item div {
  display: inline-block;
  overflow: auto;
  height: 100%;
}
.item-title {
  background: #f8f9fa;
  border-right: 1px solid #0078ff;
  height: 100%;
  width: 200px;
  padding: 27px 0px 0px 20px;
  font-size: 17px;
  font-weight: 600;
}
.list-content {
  width: calc(100% - 200px);
  word-wrap: break-word;
  word-break: normal;
  vertical-align: top;
  padding: 10px;
}
.tag_list span {
  border: 1px solid #e2e3e4;
  border-radius: 15.5px;
  /* padding: 5px 10px; */
  margin-right: 10px;
  margin-bottom: 10px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
  top: 40px;
}
.chart-contai >>> .el-date-editor .el-range-separator {
  line-height: 25px;
}
.chart-contai >>> .el-date-editor .el-range__close-icon {
  line-height: 27px;
}
.industry_right_container {
  position: relative;
}
.favourite_btn {
  /* top: 0px !important; */
}
.downContainer >>> .el-table__body-wrapper {
  overflow: auto !important;
}
.search-chart {
  margin-right: 10px;
}
.contai {
  padding: 10px;
}
</style>
